<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->
          <div class="row mb-2">
            <div class="col-md-12">
              <div
                class="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"
              >
                <div class="dropdown me-2 bg-success">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle"
                    data-bs-toggle="dropdown"
                    ><i class="ti ti-package-export me-2"></i>Import/Export</a
                  >
                  <div class="dropdown-menu dropdown-menu-end">
                    <ul>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          @click="downloadPhoneExcel"
                        >
                          <i class="ti ti-download text-blue me-1"></i> Export
                          Phone
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <button
                  class="btn btn-primary"
                  @click="goToUrl('/leads-organization/initial-info')"
                >
                  <i class="ti ti-square-rounded-plus me-2"></i>Add
                  {{ title }}
                </button>
              </div>
            </div>
          </div>

          <div class="card">
            <!-- Search -->
            <div class="card-header">
              <div v-if="loading" class="loader">Loading...</div>

              <div class="row align-items-center">
                <div class="col-md-3 mb-2">
                  <input
                    type="text"
                    v-model="filters.searchQuery"
                    class="form-control"
                    placeholder="Companies..."
                    @input="onSearch"
                  />
                </div>
                <div class="col-sm-3 mb-2">
                  <multiselect
                    v-model="filters.employee_id"
                    :options="employees"
                    track-by="id"
                    label="name"
                    placeholder="Select Employee"
                    @input="onSearch"
                  >
                  </multiselect>
                </div>
                <div class="col-sm-3 mb-2">
                  <select
                    v-model="filters.stage"
                    @change="onSearch"
                    class="form-control"
                  >
                    <option value="">Select Stage</option>
                    <option
                      v-for="(stage, i) in leadStages"
                      :key="i"
                      :value="stage.lead_stage"
                    >
                      {{ stage.lead_stage }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 mb-2">
                  <select
                    v-model="filters.priority"
                    @change="onSearch"
                    class="form-control"
                  >
                    <option value="">Select Priority</option>
                    <option
                      v-for="(priority, i) in leadPriorities"
                      :key="i"
                      :value="priority.name"
                    >
                      {{ priority.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 mb-2">
                  <select
                    v-model="filters.selectedIndustryType"
                    @change="onSearch"
                    class="form-control"
                  >
                    <option value="">Select Industries</option>
                    <option
                      v-for="(industry, index) in industryTypesArr"
                      :key="index"
                      :value="industry?.name"
                    >
                      {{ industry?.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 mb-2">
                  <multiselect
                    v-model="filters.exhibition"
                    :options="exhibitions"
                    track-by="id"
                    label="name"
                    placeholder="exhibitions"
                    @input="onSearch"
                  >
                  </multiselect>
                </div>
                <div class="col-md-3 mb-2">
                  <div
                    class="daterange-picker d-flex align-items-center justify-content-center"
                  >
                    <div class="form-sort me-2">
                      <i class="ti ti-calendar"></i>
                      <input
                        type="text"
                        class="form-control date-range bookingrange"
                        ref="dateRangeInput"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Search -->
            <div class="card-body">
              <!-- Countries List -->
              <div v-if="!isLoading" class="table-responsive custom-table">
                <a-table
                  class="table"
                  :columns="columns"
                  :data-source="data"
                  :row-selection="rowSelection"
                  row-key="id"
                  table-layout="fixed"
                  :pagination="pagination"
                  :loading="isLoading"
                  @change="handleTableChange"
                >
                  <template #bodyCell="{ column, record }">
                    <!-- Render Action Column -->
                    <template v-if="column.key === 'action'">
                      <div class="dropdown table-action">
                        <a
                          href="#"
                          class="action-icon"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          ><i class="fa fa-ellipsis-v"></i
                        ></a>
                        <div class="dropdown-menu dropdown-menu-right">
                          <a
                            v-if="hasEditPermission(record.id)"
                            class="dropdown-item"
                            href="#"
                            @click="goToEditPage(record.id)"
                          >
                            <i class="ti ti-edit text-blue"></i> Edit
                          </a>
                          <a
                            v-else
                            class="dropdown-item"
                            href="#"
                            :class="{ disabled: isPending(record.id) }"
                            @click="confirmEditRequest(record.id)"
                          >
                            <i class="ti ti-edit text-blue"></i>
                            {{
                              isPending(record.id)
                                ? "Requested"
                                : "Request for Edit"
                            }}
                          </a>
                          <a
                            v-if="hasDetailsPermission()"
                            class="dropdown-item"
                            href="#"
                            @click="handleDetailsClick(record)"
                          >
                            <i class="ti ti-eye text-blue"></i> Details
                          </a>
                          <a
                            v-else
                            class="dropdown-item"
                            href="#"
                            :class="{
                              disabled: isDetailsPending(record.id),
                            }"
                            @click="handleDetailsClick(record)"
                          >
                            <i class="ti ti-eye text-blue"></i>
                            {{
                              isDetailsPending(record.id)
                                ? "Requested for Details"
                                : record.is_disabled == "1"
                                ? "Request for Details"
                                : "Details"
                            }}
                          </a>

                          <a
                            v-if="userInfo && hasDeletePermission"
                            class="dropdown-item"
                            href="#"
                            @click="openDeleteModal(record)"
                            ><i class="ti ti-trash text-danger"></i> Delete</a
                          >
                        </div>
                      </div>
                    </template>

                    <!-- Render Initial Info -->
                    <template
                      v-else-if="
                        column.key === 'initial_info' && record?.initial_info
                      "
                    >
                      <ul class="custom-text-truncation">
                        <li>
                          {{ record?.initial_info?.organization_name }}<br />
                          <strong>Phone:</strong>
                          {{ record?.initial_info?.phone }}<br />
                          <strong v-if="record?.initial_info?.address"
                            >Address:</strong
                          >
                          {{ record?.initial_info?.address }}<br />
                          <strong v-if="record?.initial_info?.industry"
                            >Industry Type:</strong
                          >
                          {{ record?.initial_info?.industry?.type }}<br />
                        </li>
                      </ul>
                    </template>
                    <!-- Render Concern Person Info -->
                    <template
                      v-else-if="
                        column.key === 'concern_person_info' &&
                        record?.concern_person?.concern_person_info
                      "
                    >
                      <ul class="custom-text-truncation">
                        <li
                          v-for="(info, index) in record.concern_person
                            .concern_person_info"
                          :key="index"
                        >
                          <strong>Name:</strong> {{ info.name }}<br />
                          <strong>Emails:</strong> {{ info.email.join(", ")
                          }}<br />
                          <strong v-if="info.phone">Phones:</strong>
                          {{ info.phone.join(", ") }}<br />
                          <strong v-if="info.gender">Gender:</strong>
                          {{ info.gender }}<br />
                          <!-- <strong v-if="info.social_networks">Social Networks:</strong>
                          <ul>
                            <li
                              v-for="(network, i) in info.social_networks"
                              :key="i"
                            >
                              {{ network.social_media }}: {{ network.url }}
                            </li>
                          </ul> -->
                        </li>
                      </ul>
                    </template>
                    <template
                      v-else-if="
                        column.key === 'created_by' && record?.created_by
                      "
                    >
                      {{ record.created_by.name }}
                    </template>
                    <template
                      v-else-if="
                        column.key === 'created_at' && record?.created_at
                      "
                    >
                      {{ formatDate(record.created_at) }}
                    </template>
                  </template>
                </a-table>
              </div>

              <!-- Loading indicator -->
              <div v-else>
                <p>Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <lead-delete-modal v-if="isShowModal" @refresh="refresh" />
</template>

<script>
import http from "@/utils/http";
import moment from "moment";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      title: "Leads",
      loading: false,
      data: [],
      permissions: [],

      employees: [],
      exhibitions: [],
      industryTypesArr: [],

      leadStages: [
        { label: "New", value: "new" },
        { label: "In Progress", value: "in_progress" },
        { label: "Closed", value: "closed" },
      ],
      leadPriorities: [
        { name: "Very Good" },
        { name: "Good" },
        { name: "Low" },
        { name: "Very Low" },
      ],
      filters: {
        employee_id: "",
        stage: "",
        priority: "",
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
        selectedIndustryType: "",
        exhibition: "",
        searchQuery: "",
      },

      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
      },

      isLoading: false,
      selectedRowKeys: [],
      isEditMode: false,
      isShowModal: false,
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          width: "10%",
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: "Initial Info",
          key: "initial_info",
        },
        {
          title: "Concern Person Info",
          key: "concern_person_info",
        },
        {
          title: "Status",
          dataIndex: "status",
          key: "status",
          width: "10%",
          sorter: (a, b) => a.status.localeCompare(b.status),
        },
        {
          title: "Created By",
          dataIndex: "created_by",
          key: "created_by",
          width: "15%",
          sorter: (a, b) => a.created_at.localeCompare(b.created_by),
        },
        {
          title: "Created At",
          dataIndex: "created_at",
          key: "created_at",
          width: "15%",
          sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        },
        {
          title: "Action",
          key: "action",
          width: "10%",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "userPermissions"]),
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
    hasDeletePermission() {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];

      return permissions.includes("Leads Delete");
    },

  },
  watch: {
    "filters.exhibition": {
      handler() {
        this.onSearch();
      },
      deep: true,
    },
    "filters.employee_id": {
      handler() {
        this.onSearch();
      },
      deep: true,
    },
  },

  async mounted() {
    this.getCollections();
    this.getEmployees();
    this.getLeadStages();
    this.getIndustryTypes();
    this.getExhibitions();

    if (this.$refs.dateRangeInput) {

      new DateRangePicker(
        this.$refs.dateRangeInput,
        {
          startDate: moment().startOf("month"),
          endDate: moment().endOf("month"),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [
              moment().subtract(1, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "All Time": [moment("1970-01-01"), moment()],
          },
        },
        this.booking_range
      );
    }
    try {
      await this.checkLeadsPermission();
    } catch (error) {
      console.error("Error during mounting:", error);
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    async downloadPhoneExcel() {
      try {
        const response = await http.post(
          "/download-all-phone",
          {
            data: this.data,
          },
          {
            responseType: "blob",
            headers: {
              Accept: "application/octet-stream",
            },
          }
        );

        let filename = "phone_numbers.csv";

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },
    booking_range(start, end) {
      this.filters.startDate = start ? start.format("YYYY-MM-DD") : null;
      this.filters.endDate = end ? end.format("YYYY-MM-DD") : null;
      this.onSearch();
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    },
    // async filterLeads() {
    //   await this.getCollections();
    // },
    async getCollections(page = 1, pageSize = 10) {
      this.isLoading = true;
      try {
        const response = await http.get("leads", {
          params: {
            page,
            per_page: pageSize,
            search: this.filters.searchQuery || undefined,
            stage: this.filters.stage || undefined,
            priority: this.filters.priority || undefined,
            selectedIndustryType:
              this.filters.selectedIndustryType || undefined,
            exhibition: Number(this.filters.exhibition?.id) || undefined,
            employee: Number(this.filters.employee_id?.id) || undefined,
            start_date: this.filters.startDate,
            end_date: this.filters.endDate,
          },
        });

        this.data = response.data.contents.data;
        this.pagination.total = response.data.contents.total;
        this.pagination.current = response.data.contents.current_page;
        this.pagination.pageSize = response.data.contents.per_page;
      } catch (error) {
        console.error("Error:", error);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    refresh() {
      this.isShowModal = false;
      this.getCollections();
    },
    handleTableChange(pagination) {
      this.getCollections(pagination.current, pagination.pageSize);
    },
    onSearch() {
      this.pagination.current = 1;
      this.getCollections(this.pagination.current, this.pagination.pageSize);
    },

    goToUrl(path) {
      this.$router.push(path);
    },
    goToEditPage(recordId) {
      this.$router.push(`/leads-organization/${recordId}/initial-info`);
    },
    async getEmployees() {
      const endpoint = `/employees`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.employees = response.data.contents.map((employee) => {
          return {
            id: employee.id,
            name: employee?.user?.name,
          };
        });
      } catch (error) {
        //
      }
    },
    async getLeadStages() {
      const endpoint = `/lead-stages`;
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.currentStage = this.currentLeadStage;
        this.leadStages = response.data.contents.map((stage) => {
          return {
            lead_stage: stage.lead_stage,
          };
        });
      } catch (error) {}
    },
    async getIndustryTypes() {
      try {
        const response = await http.get("industries");
        this.industryTypesArr = response.data.contents.map((industry) => ({
          id: industry.id,
          name: industry.type,
        }));
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async getExhibitions() {
      const endpoint = "/exhibitions";
      const method = "get";
      try {
        const response = await http[method](endpoint);
        this.exhibitions = response.data?.contents.map((item) => ({
          id: item.id,
          name: item.name,
        }));
      } catch (error) {
        //
      }
    },
    async checkLeadsPermission() {
      console.log("call again check permission");
      if (!this.userInfo || !this.userInfo.employee) {
        console.error("User info or employee data is not available.");
        return;
      }
      const endpoint = "/check-edit-permission";
      const method = "post";
      let body = {
        employeeId: this.userInfo.employee.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.permissions = response.data.permissions || [];
      } catch (error) {
        console.error("Error checking permissions:", error);
      }
    },

    hasEditPermission(leadId) {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];

      if (permissions.includes("Leads Edit")) {
        return true;
      } else {
        return (
          this.permissions.find(
            (permission) =>
              permission.lead_id == leadId &&
              permission.status == "approved" &&
              permission.permission_type == "Edit"
          ) !== undefined
        );
      }
    },
    hasDetailsPermission() {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];

      if (permissions.includes("Leads Details")) {
        return true;
      }
      return false;
    },
    isPending(leadId) {
      const permission = this.permissions.find(
        (permission) =>
          permission.lead_id == leadId &&
          permission.permission_type === "Edit" &&
          permission.status == "pending"
      );
      return permission?.status === "pending";
    },
    isDetailsPending(leadId) {
      const permission = this.permissions.find(
        (permission) =>
          permission.lead_id == leadId &&
          permission.status == "pending" &&
          permission.permission_type === "Details"
      );
      return permission?.status === "pending";
    },
    handleDetailsClick(record) {
      const permissions = Array.isArray(this.userPermissions)
        ? this.userPermissions
        : [];
      if (permissions.includes("Leads Details")) {
        this.goToDetailsPage(record.id);
      } else if (record.is_disabled == 1) {
        this.confirmDetailsRequest(record.id);
      } else {
        this.goToDetailsPage(record.id);
      }
    },
    goToDetailsPage(recordId) {
      this.$router.push(`/leads-organization/${recordId}/leads-details`);
    },
    confirmEditRequest(recordId) {
      Swal.fire({
        title: "Are you sure?",
        text: "Would you like to request permission to edit this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, request it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.editRequest(recordId);
        }
      });
    },
    async editRequest(recordId) {
      this.loading = true;
      const endpoint = "/request-for-leads-edit";
      const method = "post";
      let body = {
        lead_id: recordId,
        employee_id: this.userInfo.employee.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.$toast.success(response.data.message);
        this.loading = false;
        const existingPermission = this.permissions.find(
          (permission) => permission.lead_id == recordId
        );
        if (existingPermission) {
          existingPermission.status = "pending";
        } else {
          this.permissions.push({ lead_id: recordId, status: "pending" });
        }
        this.checkLeadsPermission();
        this.refresh();
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.response.data.message);
      } finally {
        //
      }
    },
    confirmDetailsRequest(recordId) {
      Swal.fire({
        title: "Are you sure?",
        text: "Would you like to request access to the details page for this record?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, request it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.detailsRequest(recordId);
        }
      });
    },
    async detailsRequest(recordId) {
      this.loading = true;
      const endpoint = "/request-for-leads-details";
      const method = "post";
      let body = {
        lead_id: recordId,
        employee_id: this.userInfo.employee.id,
      };
      try {
        const response = await http[method](endpoint, body);
        this.$toast.success(response.data.message);
        this.loading = false;
        const existingPermission = this.permissions.find(
          (permission) => permission.lead_id == recordId
        );
        if (existingPermission) {
          existingPermission.status = "pending";
        } else {
          this.permissions.push({ lead_id: recordId, status: "pending" });
        }

        this.checkLeadsPermission();
      } catch (error) {
        this.loading = false;
        this.$toast.error(error.response.data.message);
      } finally {
        //
      }
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    openDeleteModal(row = "") {
      this.isShowModal = true;
      setTimeout(() => {
        this.$emitter.emit("delete-item-modal", row);
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  font-size: 20px;
  font-weight: bold;
}
.disabled {
  pointer-events: none;
  color: #6c757d;
  cursor: not-allowed;
}

.custom-text-truncation {
  list-style-type: none; /* Remove default list styles */
  margin: 0;
  padding: 0;
  width: 100%; /* Ensure the list takes up the full width */
}

.custom-text-truncation li {
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Use ellipsis for overflowing text */
  white-space: nowrap; /* Prevent the text from wrapping to the next line */
  display: block; /* Ensure list items are block-level */
  width: 100%; /* Ensure list items are responsive */
  max-width: 100%; /* Prevent content from spilling outside */
}

.custom-text-truncation li span {
  display: inline-block; /* Make sure the span behaves like inline-block */
  max-width: 200px; /* Set a max width to ensure truncation (adjust as needed) */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form-sort i {
  z-index: unset !important;
}
.dropdown a {
  border: unset !important;
  border-radius: unset !important;
}
</style>
